import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=00d875c6&scoped=true&"
import script from "./refund.vue?vue&type=script&lang=js&"
export * from "./refund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d875c6",
  null
  
)

export default component.exports